"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _excluded = ["size", "width", "height", "fill"];

var _default = function _default(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? size : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? size : _ref$height,
      _ref$fill = _ref.fill,
      fill = _ref$fill === void 0 ? '#808080' : _ref$fill,
      restProps = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement("svg", (0, _extends2["default"])({
    width: size,
    height: size,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, restProps), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M25.5209 4.16666C21.2975 4.16666 17.1689 5.41906 13.6572 7.76549C10.1455 10.1119 7.40849 13.447 5.79225 17.3489C4.176 21.2509 3.75312 25.5445 4.57707 29.6868C5.40103 33.8291 7.43481 37.6341 10.4212 40.6205C13.4077 43.6069 17.2126 45.6407 21.3549 46.4647C25.4972 47.2886 29.7908 46.8658 33.6928 45.2495C37.5948 43.6333 40.9298 40.8962 43.2763 37.3846C45.6227 33.8729 46.8751 29.7443 46.8751 25.5208C46.8696 19.859 44.618 14.4307 40.6145 10.4272C36.611 6.42376 31.1827 4.17218 25.5209 4.16666ZM25.5209 43.75C21.9155 43.75 18.3911 42.6809 15.3933 40.6778C12.3956 38.6748 10.0591 35.8278 8.67937 32.4968C7.29965 29.1659 6.93865 25.5006 7.64203 21.9645C8.3454 18.4284 10.0816 15.1803 12.631 12.6309C15.1804 10.0815 18.4285 8.34531 21.9646 7.64193C25.5007 6.93856 29.166 7.29955 32.4969 8.67928C35.8279 10.059 38.6749 12.3955 40.6779 15.3932C42.681 18.391 43.7501 21.9154 43.7501 25.5208C43.7501 30.3555 41.8295 34.9922 38.4109 38.4108C34.9923 41.8294 30.3556 43.75 25.5209 43.75Z",
    fill: fill
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M33.0418 18C32.7488 17.7074 32.3517 17.543 31.9376 17.543C31.5235 17.543 31.1264 17.7074 30.8334 18L25.5209 23.3125L20.2084 18C19.9122 17.724 19.5205 17.5737 19.1157 17.5809C18.7109 17.588 18.3247 17.752 18.0384 18.0383C17.7521 18.3246 17.5881 18.7108 17.581 19.1156C17.5738 19.5204 17.7241 19.9121 18.0001 20.2083L23.3126 25.5208L18.0001 30.8333C17.7075 31.1263 17.5431 31.5234 17.5431 31.9375C17.5431 32.3516 17.7075 32.7487 18.0001 33.0417C18.2977 33.3274 18.6918 33.491 19.1043 33.5C19.5185 33.4996 19.9157 33.3348 20.2084 33.0417L25.5209 27.7292L30.8334 33.0417C31.1262 33.3348 31.5233 33.4996 31.9376 33.5C32.3501 33.491 32.7442 33.3274 33.0418 33.0417C33.3344 32.7487 33.4987 32.3516 33.4987 31.9375C33.4987 31.5234 33.3344 31.1263 33.0418 30.8333L27.7293 25.5208L33.0418 20.2083C33.3344 19.9154 33.4987 19.5182 33.4987 19.1042C33.4987 18.6901 33.3344 18.293 33.0418 18Z",
    fill: fill
  }));
};

exports["default"] = _default;